import PropTypes from "prop-types";

export const AccentOrange = ({ children }) => {
  return <span className="accent-orange">{children}</span>;
};

AccentOrange.propTypes = {
  children: PropTypes.node,
};
